<template>
  <div class="popup_wrap tax_invoice_request_detail_pop" style="width:600px;">
    <button class="layer_close" @click.prevent="$emit('close')">close</button>

    <div class="popup_cont">
      <!-- popup_cont -->
      <h1 class="page_title">{{ $t('msg.ADD20260813.001') }}</h1>

      <div class="content_box">
        <!-- content_box -->
        <table class="tbl_row">
          <colgroup>
            <col width="160px"><col width="*">
          </colgroup>
          <tbody>
            <tr>
              <th>{{ $t('msg.ADD20260813.013') }}</th> <!-- Tax Invoice Currency -->
              <td>{{ invMethodNm }}</td>
            </tr>
            <tr>
              <th>{{ $t('msg.ADD20260813.012') }}</th> <!-- E-mail Address -->
              <td>{{ emlAddr }}</td>
            </tr>
          </tbody>
        </table>

        <table class="tbl_list font_sm gridtype mt10">
          <colgroup>
            <col width="35%">
            <col width="25%">
            <col width="40%">
          </colgroup>
          <thead>
            <tr>
              <th>{{ $t('msg.ADD20260813.026') }}</th> <!-- B/L No. -->
              <th>{{ $t('msg.ADD20260813.027') }}</th> <!-- Status -->
              <th>{{ $t('msg.ADD20260813.028') }}</th> <!-- Remark -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in detailList" :key="`${row.blNo}_${idx}`">
              <td class="text_center">{{ row.blNo }}</td>
              <td class="text_center">{{ getStatusNm(row.apvStsCd) }}</td>
              <td>{{ row.reqRsps || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div><!-- content_box // -->

      <div class="mt10 text_center">
        <a class="button gray lg" href="javascript:void(0)" @click.prevent="$emit('close')">{{ $t('msg.ADD20260813.034') }}</a> <!-- Close -->
      </div>
    </div><!-- popup_cont -->
  </div><!-- popup_wrap // -->
</template>

<script>
export default {
  name: 'TaxInvoiceRequestDetailPop',
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          detailList: []
        }
      }
    }
  },
  computed: {
    detailList () {
      return this.parentInfo.detailList || []
    },
    invMethodNm () {
      if (this.detailList.length === 0) {
        return '-'
      }
      // RMK(invMethod) - 01: CNY Consolidated / 02: CNY, USD Separate
      return this.detailList[0].invMethod === '02'
        ? this.$t('msg.ADD20260813.016')
        : this.$t('msg.ADD20260813.014')
    },
    emlAddr () {
      return this.detailList.length > 0 && this.detailList[0].emlAddr ? this.detailList[0].emlAddr : '-'
    }
  },
  methods: {
    getStatusNm (apvStsCd) {
      // CM138I 승인 상태 코드 -> 표시명 (02 Request / 03 승인 / 04 거절 / 10 취소 / 그 외 처리중)
      switch (apvStsCd) {
        case '02':
          return this.$t('msg.ADD20260813.029') // Requested
        case '03':
          return this.$t('msg.ADD20260813.031') // Approved
        case '04':
          return this.$t('msg.ADD20260813.032') // Rejected
        case '10':
          return this.$t('msg.ADD20260813.033') // Canceled
        default:
          return this.$t('msg.ADD20260813.030') // Processing (01, 05~09)
      }
    }
  }
}
</script>

<style scoped>
.tax_invoice_request_detail_pop .content_box {
  height: auto !important;
  min-height: 0 !important;
}
</style>
